<template>
  <div class="table-responsive">
    <table class="table is-fullwidth is-striped">
      <thead>
        <tr>
          <th>{{ $t("app.row") }}</th>
          <th>{{ $t("app.definition") }}</th>
          <th>{{ $t("app.percent") }}</th>
          <th>{{ $t("app.dif") }}</th>
          <th>{{ $t("app.high") }}</th>
          <th>{{ $t("app.low") }}</th>
          <th>{{ $t("app.average") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" v-bind:key="item.id">
          <td>{{ item.Sira }}</td>
          <td>{{ item.Tanim }}</td>
          <td>{{ item.Yuzde }}</td>
          <td>{{ item.Fark }}</td>
          <td>{{ item.Yuksek }}</td>
          <td>{{ item.Dusuk }}</td>
          <td>{{ item.Ortalama }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import iconv from "iconv-lite";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["symbol"]),
  },
  data: function() {
    return {
      data: [],
    };
  },
  mounted: function() {
    axios
      .get(
        process.env.VUE_APP_PROXY +
          "cmd=Getiri?symbol=" +
          this.symbol +
          "?lang=" +
          this.$i18n.locale,
        { responseType: "arraybuffer", responseEncoding: "binary" }
      )
      .then((response) => this.initJSON(response));
  },
  methods: {
    replaceAll: function(string, search, replace) {
      return string.split(search).join(replace);
    },
    initJSON: function(response) {
      if (
        iconv.decode(Buffer.from(response.data), "ISO-8859-9") &&
        this.$i18n.locale == "en"
      ) {
        response.data = iconv.decode(Buffer.from(response.data), "ISO-8859-9");
        response.data = this.replaceAll(response.data,"Gün","Day");
        response.data = this.replaceAll(response.data,"Yıl","Year");
        response.data = this.replaceAll(response.data,"Hafta","Week");
        response.data = this.replaceAll(response.data,"Ay","Mounth");
      }
      this.data = JSON.parse(
        iconv.decode(Buffer.from(response.data), "ISO-8859-9")
      );
    },
  },
};
</script>
